
let treeChildren = (data, Vue) => {
  var arr = [
    // {
    //   title: '和',
    //   align: 'center',
    //   width: '40',
    //   render: (h, row) => {
    //     return <span>{row.row.sum_json.sum}</span>;
    //   }
    // }
  ];
  if (data) {
    var a = data[0].sum_json.nums;
    var keys = Object.keys(a);
    for (let i = 0; i < keys.length; i++) {
      var obj = {};
      obj.title = `${keys[i]}`;
      obj.align = 'center';
      obj.className = `tree_table_children`;
      obj.render = (h, row) => {

        var num = row.row.sum_json.nums[keys[i]];

        if (num == 0) {
          return <span title={num} class="red">{row.row.sum_json.sum}</span>;
        } else if (data[0].sum_json.nums[keys[i]] > row.index) {
          return <span title={num} class="divide_lost_info lost_info">{num}</span>;
        } else {
          return <a class="lost_info" title={num} style={{ whiteSpace: 'nowrap' }}>{num}</a>;
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};
let heChildren = data => {
  var arr = [];
  var shape = ['大', '小', '单', '双'];
  var str = ['big', 'small', 'single', 'double'];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';
      // obj.width = '37';
      obj.className = `join_table_children`;
      obj.render = (h, row) => {
        var sum = row.row.sum_json;
        if (i < 2) {
          var num = data[0].sum_json.bigSmall[str[i]];
          var n = sum.bigSmall[str[i]];
          if (n == 0) {
            return <span class={`table_join_${i % 2}`}>{shape[i]}</span>;
          } else if (num > row.index) {
            return <span class="divide_lost_info lost_info">{n}</span>;
          } else {
            return <span class="lost_info">{n}</span>;
          }
          // } else {
          //   return <span class="table_join">{sum.bigSmall[str[i]]}</span>;
          // }
        } else if (1 < i && i < 4) {
          var num = data[0].sum_json.singleDouble[str[i]];
          var n = sum.singleDouble[str[i]];
          if (n == 0) {
            return <span class={`table_join_${i % 2}`}>{shape[i]}</span>;
          } else if (num > row.index) {
            return <span class="divide_lost_info lost_info">{n}</span>;
          } else {
            return <span class="lost_info">{n}</span>;
          }
          // } else {
          //   return <span class="table_join">{sum.singleDouble[str[i]]}</span>;
          // }
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};
let lostTreeChildren = data => {
  var arr = [];
  // return arr;
  var a = data[0].sum_json.nums;
  var keys = Object.keys(a);
  for (let i = 0; i < keys.length; i++) {
    var obj = {};
    obj.title = `${keys[i]}`;
    obj.align = 'center';
    obj.render = (h, row) => {
      // return <span>3</span>;
      var key = row.row.key;
      var n = row.row.lost.sumJson.nums;
      if (key != 'averageOmit') {
        return <span>{n[keys[i]][key] ? n[keys[i]][key] : 0}</span>;
      }
    };
    arr.push(obj);
  }
  return arr;
};

let lostHeChildren = data => {
  var arr = [];
  var shape = ['大', '小', '单', '双'];
  var str = ['big', 'small', 'single', 'double'];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';
      // obj.width = '37';
      obj.className = `join_table_children`;
      obj.render = (h, row) => {
        // var sum = row.row.sum_json;
        var key = row.row.key;
        var n = row.row.lost.sumJson;
        if (i < 2) {
          return <span>{n.bigSmall[str[i]][key]}</span>;
        } else if (1 < i && i < 4) {
          return <span>{n.singleDouble[str[i]][key]}</span>;
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};
const choose5 = (data, ballindex) => {
  let list = Vue => {
    var ball = ['一', '二', '三', '四', '五'];
    let arr = [
      {
        title: '期数',
        align: 'center',
        key: 'issue_id',
        className: `table_issueId`,
        width: 80
      },
      {
        title: '开奖号码',
        align: 'center',
        width: 100,
        className: `table_issueId`,
        render: (h, { row }) => {
          return (
            <div class="balls">
              {row.balls.split(',').map((x, i) => {
                return <span key={i}>{x}</span>;
              })}
            </div>
          );
        }
      },
      {
        title: `和值走势`,
        align: 'center',
        className: `table_issueId`,
        children: treeChildren(data, Vue)
      },
      {
        title: `和值`,
        align: 'center',
        width: 30,
        className: `table_issueId`,
        render: (h, { row }) => {
          return <span>{row.sum_json.sum}</span>;
        }
      },
      {
        title: `和尾`,
        align: 'center',
        width: 30,
        className: `table_issueId`,
        render: (h, { row }) => {
          var num = row.sum_json.sum;
          return <span>{num.toString().slice(-1)}</span>;
        }
      }
    ];
    return arr;
  };
  let lostList = Vue => {
    let arr = [
      {
        title: '数据统计',
        align: 'center',
        key: 'name',
        className: `table_issueId`,
        width: 344
      },
      {
        title: '和值走势',
        align: 'center',
        children: lostTreeChildren(data)
      },
      {
        title: '和值',
        align: 'center',
        render: (h, { row }) => {
          return <span>0</span>;
        }
      },
      {
        title: '尾值',
        align: 'center',
        render: (h, { row }) => {
          return <span>0</span>;
        }
      }
    ];

    return arr;
  };
  return { list, lostList };
};

export default choose5;



// WEBPACK FOOTER //
// ./src/pages/Trend/Hezhizoushi/columns/choose5.js